import { render } from "./kalio-contact-modal.vue?vue&type=template&id=2baf8b6f"
import script from "./kalio-contact-modal.vue?vue&type=script&lang=js"
export * from "./kalio-contact-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__